(function () {
  'use strict';

  var SELECTOR = '[data-media-marquee]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Duplicated cards stay clickable for pointer users; they are only removed
  // from the accessibility tree and the tab order to avoid announcing twice.
  function sanitizeClone(group) {
    group.setAttribute('aria-hidden', 'true');
    group.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  function rebuild(root) {
    var track = root.querySelector('.media-marquee__track');
    if (!track) return;

    var groups = track.querySelectorAll('.media-marquee__group');
    if (!groups.length) return;

    var source = groups[0];
    if (!track.getAttribute('data-seed-html')) {
      track.setAttribute('data-seed-html', source.innerHTML);
    }

    source.innerHTML = track.getAttribute('data-seed-html');
    Array.prototype.slice.call(groups, 1).forEach(function (node) {
      node.remove();
    });

    if (prefersReducedMotion()) {
      root.classList.add('is-ready');
      root.setAttribute('data-reduced-motion', 'true');
      return;
    }

    root.removeAttribute('data-reduced-motion');

    var seed = Array.prototype.slice.call(source.children).map(function (node) {
      return node.cloneNode(true);
    });
    if (!seed.length) return;

    var viewport = root.querySelector('.media-marquee__viewport') || root;
    var guard = 0;
    while (source.scrollWidth < viewport.offsetWidth && guard < 20) {
      seed.forEach(function (node) {
        source.appendChild(node.cloneNode(true));
      });
      guard += 1;
    }

    var clone = source.cloneNode(true);
    sanitizeClone(clone);
    track.appendChild(clone);
    root.classList.add('is-ready');
  }

  function init(root) {
    if (!root || root.getAttribute('data-media-marquee-ready') === 'true') return;
    root.setAttribute('data-media-marquee-ready', 'true');
    rebuild(root);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        rebuild(root);
      }, 150);
    });

    if (window.matchMedia) {
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var onMotionChange = function () {
        rebuild(root);
      };
      if (motionQuery.addEventListener) {
        motionQuery.addEventListener('change', onMotionChange);
      } else if (motionQuery.addListener) {
        motionQuery.addListener(onMotionChange);
      }
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll(SELECTOR).forEach(function (root) {
      root.removeAttribute('data-media-marquee-ready');
      var track = root.querySelector('.media-marquee__track');
      if (track) track.removeAttribute('data-seed-html');
      init(root);
    });
  });
})();
